import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
  "Lead Code",
  "Lead Type",
  "Lead Name",
  "Mobile No.",
  "Make",
  "Model",
  "Stage",  
  "Source",
  "Created Date",
  "Status",
  "Allocate",
  "Action"
];

export const TABLE_DATA = [
  { id: 1, leadtype: "Warm Lead", leadname: "John Doe", mobileno: "1234567890", make: "Toyota", model: "Camry", variant: "XSE", color: "Blue", source: "Website", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 2, leadtype: "Hot Lead", leadname: "Jane Smith", mobileno: "0987654321", make: "Honda", model: "Civic", variant: "EX", color: "Red", source: "Referral", status: "Inactive", allocate: "No", actions: "Edit/Delete" },
  { id: 3, leadtype: "Cold Lead", leadname: "Michael Johnson", mobileno: "1112223333", make: "Ford", model: "Mustang", variant: "GT", color: "Black", source: "Event", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 4, leadtype: "Warm Lead", leadname: "John Doe", mobileno: "1234567890", make: "Toyota", model: "Camry", variant: "XSE", color: "Blue", source: "Website", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 5, leadtype: "Cold Lead", leadname: "Jane Smith", mobileno: "0987654321", make: "Honda", model: "Civic", variant: "EX", color: "Red", source: "Referral", status: "Inactive", allocate: "No", actions: "Edit/Delete" },
  { id: 6, leadtype: "Warm Lead", leadname: "Michael Johnson", mobileno: "1112223333", make: "Ford", model: "Mustang", variant: "GT", color: "Black", source: "Event", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 7, leadtype: "Hot Lead", leadname: "John Doe", mobileno: "1234567890", make: "Toyota", model: "Camry", variant: "XSE", color: "Blue", source: "Website", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 8, leadtype: "Warm Lead", leadname: "Jane Smith", mobileno: "0987654321", make: "Honda", model: "Civic", variant: "EX", color: "Red", source: "Referral", status: "Inactive", allocate: "No", actions: "Edit/Delete" },
  { id: 9, leadtype: "Warm Lead", leadname: "Michael Johnson", mobileno: "1112223333", make: "Ford", model: "Mustang", variant: "GT", color: "Black", source: "Event", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 10, leadtype: "Cold Lead", leadname: "John Doe", mobileno: "1234567890", make: "Toyota", model: "Camry", variant: "XSE", color: "Blue", source: "Website", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 11, leadtype: "Warm Lead", leadname: "Jane Smith", mobileno: "0987654321", make: "Honda", model: "Civic", variant: "EX", color: "Red", source: "Referral", status: "Inactive", allocate: "No", actions: "Edit/Delete" },
  { id: 12, leadtype: "Warm Lead", leadname: "Michael Johnson", mobileno: "1112223333", make: "Ford", model: "Mustang", variant: "GT", color: "Black", source: "Event", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 13, leadtype: "Hot Lead", leadname: "John Doe", mobileno: "1234567890", make: "Toyota", model: "Camry", variant: "XSE", color: "Blue", source: "Website", status: "Active", allocate: "Yes", actions: "Edit/Delete" },
  { id: 14, leadtype: "Warm Lead", leadname: "Jane Smith", mobileno: "0987654321", make: "Honda", model: "Civic", variant: "EX", color: "Red", source: "Referral", status: "Inactive", allocate: "No", actions: "Edit/Delete" },
  { id: 15, leadtype: "Warm Lead", leadname: "Michael Johnson", mobileno: "1112223333", make: "Ford", model: "Mustang", variant: "GT", color: "Black", source: "Event", status: "Active", allocate: "Yes", actions: "Edit/Delete" }
];

export const keyMapping = {
  "Lead Code": "lead_code",
  "Lead Type": "priority_name",
  "Lead Name": "full_name",
  "Mobile No.": "mobile_no",
  "Make": "make_name",
  "Model": "model_name",
  "Variant": "variant",
  "Stage":"stage",
  "Source": "source_name",
  "Created Date":"created_at",
  "Status": "status",
  "Allocate": "allocate",
  "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "view", icon:eyeIcon, label: "view" }
  ]
};
